export default "__VITE_ASSET__y7ZR$fYO__"